import {ChangeDetectionStrategy, Component, Input} from '@angular/core';
import { ServicingFacilityContactDetailsPAC } from '@shared/model';

@Component({
    selector: 'servicing-facility-panel-immediate',
    templateUrl: './servicing-facility-panel-immediate.component.html',
    styleUrls: ['./servicing-facility-panel-immediate.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class ServicingFacilityPanelImmediateComponent {
  @Input() immediateContactDetails: ServicingFacilityContactDetailsPAC;
  @Input() isInternal: boolean;
}
